import { updateModel } from './updateModel'

var running = false

function stopTimer() {
    running = false
}

function timerLoop() {
    if (running) {
        updateModel()
        requestAnimationFrame(timerLoop)
    }
}

function startTimer() {
    if (!running) {
        running = true
        timerLoop()
    }
}

export { stopTimer, timerLoop, startTimer }



//////////////////
// WEBPACK FOOTER
// ./src/timer.js
// module id = 23
// module chunks = 0